module.exports = __webpack_public_path__ + "static/img/product_banner_23_zh.6f9716a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_23_zh.png
// module id = Zuf6
// module chunks = 34